import { render, staticRenderFns } from "./giftSetting.vue?vue&type=template&id=53e05682&scoped=true&"
import script from "./giftSetting.vue?vue&type=script&lang=js&"
export * from "./giftSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e05682",
  null
  
)

export default component.exports